export default "/_next/static/9b9a9dba0514094348a97f11447cbdee.png";